export const tertiaryColor = '0x794100';
